import { apiFetch, apiUpload } from '@/lib/api';
import type { FlyerCategory, FlyerCategoryInput, FlyerTemplate, FlyerTemplateInput } from '@/types/flyer';

const C = '/flyer-manager/categories';
const T = '/flyer-manager/templates';

export const listFlyerCategories = () => apiFetch<FlyerCategory[]>(C);
export const createFlyerCategory = (b: FlyerCategoryInput) =>
  apiFetch<FlyerCategory>(C, { method: 'POST', body: JSON.stringify(b) });
export const updateFlyerCategory = (id: string, b: FlyerCategoryInput) =>
  apiFetch<FlyerCategory>(`${C}/${encodeURIComponent(id)}`, { method: 'PUT', body: JSON.stringify(b) });
export const deleteFlyerCategory = async (id: string) => {
  await apiFetch(`${C}/${encodeURIComponent(id)}`, { method: 'DELETE' });
};
export const listFlyerTemplates = () => apiFetch<FlyerTemplate[]>(T);
export const getFlyerTemplate = (id: string, lang = 'en') =>
  apiFetch<FlyerTemplate>(`${T}/${encodeURIComponent(id)}?lang=${encodeURIComponent(lang)}`);
export const createFlyerTemplate = (b: FlyerTemplateInput) =>
  apiFetch<FlyerTemplate>(T, { method: 'POST', body: JSON.stringify(b) });
export const updateFlyerTemplate = (id: string, b: FlyerTemplateInput) =>
  apiFetch<FlyerTemplate>(`${T}/${encodeURIComponent(id)}`, { method: 'PUT', body: JSON.stringify(b) });
export const deleteFlyerTemplate = async (id: string) => {
  await apiFetch(`${T}/${encodeURIComponent(id)}`, { method: 'DELETE' });
};
export const setTemplateBackground = (id: string, generationId: string) =>
  apiFetch<FlyerTemplate>(`${T}/${encodeURIComponent(id)}/background`, {
    method: 'POST', body: JSON.stringify({ generation_id: generationId }),
  });
export const pruneTemplateBackground = (id: string, keepAttachmentId: string) =>
  apiFetch<FlyerTemplate>(`${T}/${encodeURIComponent(id)}/background`, {
    method: 'POST', body: JSON.stringify({ keep_attachment_id: keepAttachmentId }),
  });
// /attachments (owner_type='template') responds with the DB uuid in `uuid`;
// `id` is a numeric hash of that uuid (see routes/attachments.js), not the
// row identifier we need for the prune call below.
export const uploadTemplateBackground = (id: string, file: File) => {
  const fd = new FormData();
  fd.append('file', file, file.name);
  fd.append('owner_type', 'template');
  fd.append('owner_id', id);
  fd.append('attachment_type', 'background');
  return apiUpload<{ id: number; uuid: string }>('/attachments', fd);
};
